import { render, staticRenderFns } from "./StoryPublication.vue?vue&type=template&id=396056f0&"
import script from "./StoryPublication.vue?vue&type=script&lang=js&"
export * from "./StoryPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports